import adapting_to_change_img from '../assets/images/courses/adapting-to-change/course.jpg';
import collaboration_fundamentals_img from '../assets/images/courses/collaboration-fundamentals/tittle.jpg';
import communication_basics_img from '../assets/images/courses/communication-basics/course.png';
import communication_styles_img from '../assets/images/courses/communication-styles/course.png';
import emotional_intelligence_img from '../assets/images/courses/emotional-intelligence/course.jpg';
import jumpstart_communicator_img from '../assets/images/courses/jumpstart-communicator/course.png';
import perception_understanding_img from '../assets/images/courses/perception-understanding/course.jpg';
import team_players_img from '../assets/images/courses/team-players/intro.jpg';
import team_players_collaboration_img from '../assets/images/courses/teamplayer&collaboration/course.jpg';
import {
  AdaptingToChange1,
  AdaptingToChange2,
  AdaptingToChange3,
  AdaptingToChange4,
  AdaptingToChangeQuiz,
} from '../components/Course/Chapters/AdaptingToChange';
import { TeamPlayersAndCollaborationChapter1 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter1';
import { TeamPlayersAndCollaborationChapter10 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter10';
import { TeamPlayersAndCollaborationChapter11 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter11';
import { TeamPlayersAndCollaborationChapter12 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter12';
import { TeamPlayersAndCollaborationChapter13 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter13';
import { TeamPlayersAndCollaborationChapter14 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter14';
import { TeamPlayersAndCollaborationChapter2 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter2';
import { TeamPlayersAndCollaborationChapter3 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter3';
import { TeamPlayersAndCollaborationChapter4 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter4';
import { TeamPlayersAndCollaborationChapter5 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter5';
import { TeamPlayersAndCollaborationChapter6 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter6';
import { TeamPlayersAndCollaborationChapter7 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter7';
import { TeamPlayersAndCollaborationChapter8 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter8';
import { TeamPlayersAndCollaborationChapter9 } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Chapter9';
import { Quiz } from '../components/Course/Chapters/BuildingTeamworkAndCollaboration/Quiz';
import { CollaborationFundamentalsChapter1 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter1';
import { CollaborationFundamentalsChapter2 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter2';
import { CollaborationFundamentalsChapter3 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter3';
import { CollaborationFundamentalsChapter4 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter4';
import { CollaborationFundamentalsChapter5 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter5';
import { CollaborationFundamentalsChapter6 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter6';
import { CollaborationFundamentalsChapter7 } from '../components/Course/Chapters/CollaborationFundamentals/Chapter7';
import { CollaborationFundamentalsQuiz } from '../components/Course/Chapters/CollaborationFundamentals/Quiz';
import {
  CommunicationBasicsChapter1,
  CommunicationBasicsChapter2,
  CommunicationBasicsChapter3,
  CommunicationBasicsChapter4,
  CommunicationBasicsChapter5,
  CommunicationBasicsChapter6,
  CommunicationBasicsChapter7,
  CommunicationBasicsChapter8,
  CommunicationBasicsChapter9,
  CommunicationBasicsChapter10,
  CommunicationBasicsChapter11,
  CommunicationBasicsChapter12,
  CommunicationBasicsChapter13,
  CommunicationBasicsChapter14,
  CommunicationBasicsQuiz,
} from '../components/Course/Chapters/CommunicationBasics';
import {
  CommunicationStylesChapter1,
  CommunicationStylesChapter2,
  CommunicationStylesChapter3,
  CommunicationStylesChapter4,
  // Quiz,
  PostAssessmentQuiz,
} from '../components/Course/Chapters/CommunicationStyles';
import {
  EmotionalIntelligence1,
  EmotionalIntelligence2,
  EmotionalIntelligence3,
  EmotionalIntelligence4,
  EmotionalIntelligence5,
  EmotionalIntelligence6,
  EmotionalIntelligence7,
  EmotionalIntelligenceQuiz,
} from '../components/Course/Chapters/EmotionalIntelligence';
import {
  JumpStartChapter1,
  JumpStartChapter2,
  JumpStartChapter3,
  JumpStartChapter4,
  JumpStartChapter5,
  JumpStartChapter6,
  JumpStartChapter7,
  Quiz1,
} from '../components/Course/Chapters/JumpStartCommunicator';
import {
  PerceptionAndUnderstandingChapter1,
  PerceptionAndUnderstandingChapter2,
  PerceptionAndUnderstandingChapter3,
  PerceptionAndUnderstandingChapter4,
  PerceptionAndUnderstandingChapter5,
  PerceptionAndUnderstandingChapter6,
  PerceptionAndUnderstandingChapter7,
  PerceptionAndUnderstandingChapter8,
  PerceptionAndUnderstandingChapter9,
  PerciptionQuiz,
} from '../components/Course/Chapters/PerceptionAndUnderstanding';
import { TeamPlayersChapter1 } from '../components/Course/Chapters/TeamPlayers/Chapter1';
import { TeamPlayersChapter2 } from '../components/Course/Chapters/TeamPlayers/Chapter2';
import { TeamPlayersChapter3 } from '../components/Course/Chapters/TeamPlayers/Chapter3';
import { TeamPlayersChapter4 } from '../components/Course/Chapters/TeamPlayers/Chapter4';
import { TeamPlayersChapter5 } from '../components/Course/Chapters/TeamPlayers/Chapter5';
import { TeamPlayersChapter6 } from '../components/Course/Chapters/TeamPlayers/Chapter6';
import { TeamPlayersChapter7 } from '../components/Course/Chapters/TeamPlayers/Chapter7';
import { TeamPlayersChapter8 } from '../components/Course/Chapters/TeamPlayers/Chapter8';
import { TeamPlayersChapterQuiz } from '../components/Course/Chapters/TeamPlayers/Quiz';

import { Course, CourseModule } from './courses.types';
export const courseModules: CourseModule[] = [
  {
    id: 'eb7b1338-7fa1-4673-9b2f-4fe30c2a9069',
    name: 'Effective communication and listening skills',
  },
  {
    id: '74629550-e06b-4a7a-a59e-2d16b5c84447',
    name: 'Understanding self and others',
  },
  {
    id: '18473415-771b-431d-9d95-3e5dff0c9a17',
    name: 'Collaboration Fundamentals',
  },
];

export const courses: Course[] = [
  {
    id: '0b1b086c-3f2e-430c-bff6-75097a79761e',
    module_id: 'eb7b1338-7fa1-4673-9b2f-4fe30c2a9069',
    name: 'Jumpstart Communicator',
    course_image: jumpstart_communicator_img,
    sections: [
      {
        id: '4f8c6c62-da3b-480c-969d-a2a945d027a7',
        name: '',
        chapters: [
          {
            id: '97619d13-8985-40d6-b16b-3ecd1e67567f',
            name: 'Introduction',
            index: 1,
            content: JumpStartChapter1,
            completion_percentage: 13,
          },
          {
            id: 'fd7be45f-c8d1-419d-9407-60d931551146',
            name: 'What Is Communication?',
            index: 2,
            content: JumpStartChapter2,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/jumpstart_communicator/chapter_2/jumpstart-02-01.mp4',
            ],
          },
          {
            id: '793f6d0e-2c51-4df5-b526-2b282724260f',
            name: 'Why Does Communication Fail?',
            index: 3,
            content: JumpStartChapter3,
            completion_percentage: 13,
          },
          {
            id: '43472023-17df-4363-8878-9d18fdfd9b74',
            name: 'Why Communication Skills Matter?',
            index: 4,
            content: JumpStartChapter4,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/jumpstart_communicator/chapter_4/jumpstart-04-01.mp4',
            ],
          },
          {
            id: '1087fc0c-37c1-4846-a2b9-e16c963cf417',
            name: 'Choosing the Right Communication Medium',
            index: 5,
            content: JumpStartChapter5,
            completion_percentage: 13,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/jumpstart_communicator/chapter_5/jumpstart-05-01.mp4',
            ],
          },
          {
            id: 'a7d830fa-1176-4aa2-aeae-ee4c74ab3d0a',
            name: 'How to Remove Five Common Communication Barriers',
            index: 6,
            content: JumpStartChapter6,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/jumpstart_communicator/chapter_6/jumpstart-06-01.mp4',
            ],
          },
        ],
      },
      {
        id: 'd6b89abe-3486-429d-aa51-f57323112980',
        name: 'CONCLUSION',
        chapters: [
          {
            id: '3be28db4-42f7-4b7f-bbe6-f468ae219201',
            name: 'Summary',
            index: 7,
            content: JumpStartChapter7,
            completion_percentage: 13,
          },
          {
            id: '38cab197-cc2c-4a55-825a-8368b2bb1372',
            name: 'Quiz',
            index: 8,
            content: Quiz1,
            disableContentScroll: true,
            completion_percentage: 12,
          },
        ],
      },
    ],
    description:
      '<p>In this course, you’ll learn how to define communication, the types of communication we use at work, how to choose the right delivery method for your message, and how to remove barriers to having it understood. </p>',
    progress_color: '#1c09f8',
    disabled: false,
  },
  {
    id: '92d6f6cf-d6cd-4f3b-9515-c27b47d860ff',
    module_id: 'eb7b1338-7fa1-4673-9b2f-4fe30c2a9069',
    name: 'Workplace Communication Basics',
    course_image: communication_basics_img,
    sections: [
      {
        id: 'e9b1303d-bc85-4d49-9d15-c94e2ad1b3f2',
        name: 'INTRODUCTION',
        chapters: [
          {
            id: 'f332d150-8a7c-4112-b34c-635913134a13',
            name: 'How to Use Verbal, Nonverbal, and Written Communication',
            index: 1,
            content: CommunicationBasicsChapter1,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_1/workplacebasic-01-01.mp4',
            ],
          },
        ],
      },
      {
        id: '872a69b7-0e28-4701-b7a3-a67ab02b2640',
        name: 'VERBAL COMMUNICATION',
        chapters: [
          {
            id: '1130183b-639b-4240-8073-a7a0fb416b26',
            name: 'Improving Your Verbal Communication Skills',
            index: 2,
            content: CommunicationBasicsChapter2,
            completion_percentage: 6,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_2/workplacebasic-02-01.mp4',
            ],
          },
          {
            id: 'de6547b5-298a-4bd1-8f21-e0df15a2f801',
            name: 'Starting a Conversation',
            index: 3,
            content: CommunicationBasicsChapter3,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_3/workplacebasic-03-01.mp4',
            ],
          },
          {
            id: 'd516aa29-4073-4687-a274-94d942f40854',
            name: 'Strategies for Effective Listening',
            index: 4,
            content: CommunicationBasicsChapter4,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_4/workplacebasic-04-01.mp4',
            ],
          },
          {
            id: '755d74e8-dc44-44c4-8aee-301ba6c2ccb2',
            name: 'Asking Closed Versus Open Questions',
            index: 5,
            content: CommunicationBasicsChapter5,
            completion_percentage: 6,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_5/workplacebasic-05-01.mp4',
            ],
          },
          {
            id: 'bafb65dd-07e9-45e6-b019-a2a24d0fe387',
            name: 'Ending a Conversation Positively',
            index: 6,
            content: CommunicationBasicsChapter6,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_6/workplacebasic-06-01.mp4',
            ],
          },
        ],
      },
      {
        id: '95e8a03a-87e2-46f6-b565-b9aa7fdd5c28',
        name: 'WRITTEN COMMUNICATION',
        chapters: [
          {
            id: '6961e488-c33b-4e8c-9044-06d0c43bcadd',
            name: 'Improving Your Business Writing Skills',
            index: 7,
            content: CommunicationBasicsChapter7,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_7/workplacebasic-07-01.mp4',
            ],
          },
          {
            id: '84dcd17d-c845-4334-9712-253f1610b4b7',
            name: 'How to Write with Purpose',
            index: 8,
            content: CommunicationBasicsChapter8,
            completion_percentage: 6,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_8/workplacebasic-08-01.mp4',
            ],
          },
          {
            id: '4920ded8-1bc5-4949-90ef-a15f202234ee',
            name: 'Choosing the Right Writing Medium',
            index: 9,
            content: CommunicationBasicsChapter9,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_9/workplacebasic-09-01.mp4',
            ],
          },
          {
            id: '4e237045-6c91-4b8d-b908-9395cc5a3dbc',
            name: 'Writing for Your Audience',
            index: 10,
            content: CommunicationBasicsChapter10,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_10/workplacebasic-10-01.mp4',
            ],
          },
          {
            id: '96b82e5e-a11a-424c-a0d2-a2a6fd32a6ff',
            name: 'How to Structure Your Writing',
            index: 11,
            content: CommunicationBasicsChapter11,
            completion_percentage: 6,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_11/workplacebasic-11-01.mp4',
            ],
          },
          {
            id: '151cc8b6-491f-4cd5-a1c6-49b186bb5675',
            name: 'How to Improve Your Grammar, Spelling, and Punctuation',
            index: 12,
            content: CommunicationBasicsChapter12,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_12/workplacebasic-12-01.mp4',
            ],
          },
          {
            id: 'cd68cd54-dfac-4c19-8a20-cfc58255c78b',
            name: 'How to Edit and Proofread Your Work',
            index: 13,
            content: CommunicationBasicsChapter13,
            completion_percentage: 7,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/workplace_communication_basics/chapter_13/workplacebasic-13-01.mp4',
            ],
          },
        ],
      },
      {
        id: 'd6b89abe-3486-429d-aa51-f57323112980',
        name: 'CONCLUSION',
        chapters: [
          {
            id: '59b3f79f-24c5-4c58-83e2-1188e862bcac',
            name: 'Summary',
            index: 14,
            content: CommunicationBasicsChapter14,
            completion_percentage: 6,
          },
          {
            id: 'af761a2e-24b0-4478-af4a-0842c9cd16aa',
            name: 'Quiz',
            index: 15,
            disableContentScroll: true,
            content: CommunicationBasicsQuiz,
            completion_percentage: 7,
          },
        ],
      },
    ],
    description:
      '<p>In this module, you’ll learn why having excellent communication skills is so important in the workplace, and how you can improve yours.</p>',
    progress_color: '#6300f5',
    disabled: true,
    disabled_description:
      'Please complete Jumpstart Communicator module before starting this module. Thanks',
  },
  {
    id: 'abb1771f-d555-47c9-961c-9bffefbd7951',
    module_id: 'eb7b1338-7fa1-4673-9b2f-4fe30c2a9069',
    name: 'Effective Communication With Different Communication Styles',
    course_image: communication_styles_img,
    sections: [
      {
        id: 'c9f3605c-47b9-4324-9e41-088b31e073f8',
        name: '',
        chapters: [
          {
            id: 'dd1a9c61-5789-48e5-9252-3c80847b64ac',
            name: 'What is a Communication Style?',
            index: 1,
            content: CommunicationStylesChapter1,
            completion_percentage: 20,
          },
          {
            id: 'f7905a29-f712-4519-a529-dac4bf207f46',
            name: 'Understanding Different Styles',
            index: 2,
            content: CommunicationStylesChapter2,
            completion_percentage: 20,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_1/effective_communication/chapter_2/effectiveCommunication-02-01.mp4',
            ],
          },
          {
            id: 'ac4efa31-a198-4a31-bbdf-bbe8e8d55f5b',
            name: 'How to Adapt to Different Styles',
            index: 3,
            content: CommunicationStylesChapter3,
            completion_percentage: 20,
          },
        ],
      },
      {
        id: 'fe4717dd-a9b1-4406-b5bb-4b1c0ee75d46',
        name: 'CONCLUSION',
        chapters: [
          {
            id: 'c793c79d-c5c1-425e-91b7-7b7c3483309d',
            name: 'Summary',
            index: 4,
            content: CommunicationStylesChapter4,
            completion_percentage: 20,
          },
          {
            id: '4b015d7c-2368-47ba-ac15-3dc35fc981d5',
            name: 'Post-Assessment',
            index: 5,
            content: PostAssessmentQuiz,
            disableContentScroll: true,
            completion_percentage: 20,
          },
        ],
      },
    ],
    description:
      '<p>In this course, you’ll learn four communication styles, how to identify each, and how to adapt your own communication approach.</p>',
    progress_color: '#02abfe',
    disabled: true,
    disabled_description:
      'Please complete Workplace Communication Basics module before starting this module. Thanks',
  },
  {
    id: 'e38f6a77-5c97-4118-92c8-e080a0111bd7',
    module_id: '74629550-e06b-4a7a-a59e-2d16b5c84447',
    name: 'Perception & Understanding Preferences',
    course_image: perception_understanding_img,
    sections: [
      {
        id: '0102f09d-7b43-4f2f-9685-f893234b85a3',
        name: 'INTRODUCTION',
        chapters: [
          {
            id: '6a205cc4-2f50-489f-83b8-4f95c8f08645',
            name: 'Overview',
            index: 1,
            content: PerceptionAndUnderstandingChapter1,
            completion_percentage: 10,
          },
        ],
      },
      {
        id: '35be4ebb-734b-43d9-9fa8-dcc1edcaec68',
        name: 'Perception',
        chapters: [
          {
            id: 'b3045f7e-05f8-422e-a3f2-b3806c145d80',
            name: 'Perception & The Ladder of Inference',
            index: 2,
            content: PerceptionAndUnderstandingChapter2,
            completion_percentage: 10,
          },
        ],
      },
      {
        id: '66cd15b4-c996-421e-aa3e-6d1849222fa8',
        name: 'Insights Discovery',
        chapters: [
          {
            id: '58181a06-5fb6-4804-a855-658c462e2230',
            name: 'Preferences',
            index: 3,
            content: PerceptionAndUnderstandingChapter3,
            completion_percentage: 10,
          },
          {
            id: 'e073e8bc-a3a7-40d3-9f9d-1d881b18500d',
            name: 'Insights Discovery',
            index: 4,
            content: PerceptionAndUnderstandingChapter4,
            completion_percentage: 10,
          },
          {
            id: 'e9f653d6-0b97-4206-ac17-53ca9c35b661',
            name: 'Color Energies & Preferences',
            index: 5,
            content: PerceptionAndUnderstandingChapter5,
            completion_percentage: 10,
          },
        ],
      },
      {
        id: '6aad706e-794d-443e-bd7b-7d86f2092eb9',
        name: 'Connecting with Others',
        chapters: [
          {
            id: '0bfaa520-fed7-4d4a-a10c-de5fd655d06d',
            name: 'Recognizing Type',
            index: 6,
            content: PerceptionAndUnderstandingChapter6,
            completion_percentage: 10,
          },
          {
            id: 'e79c427a-0c41-4d0e-b56e-34d90041782b',
            name: 'Stress & Behavioral Style',
            index: 7,
            content: PerceptionAndUnderstandingChapter7,
            completion_percentage: 10,
          },
          {
            id: 'fedbc4ce-86ce-4d6d-9022-48fe7a674cd5',
            name: 'Adapting to Connect',
            index: 8,
            content: PerceptionAndUnderstandingChapter8,
            completion_percentage: 10,
          },
        ],
      },
      {
        id: '969cd60c-8a87-4403-9de2-f25a50853c4d',
        name: 'Conclusion',
        chapters: [
          {
            id: 'bdf90edd-fdcc-4648-b09a-d6e75a38d009',
            name: 'Summary',
            index: 9,
            content: PerceptionAndUnderstandingChapter9,
            completion_percentage: 10,
          },
          {
            id: '2801ca8a-e21f-499f-9271-bd0b30b24a5b',
            name: 'Quiz',
            index: 10,
            content: PerciptionQuiz,
            completion_percentage: 10,
            disableContentScroll: true,
          },
        ],
      },
    ],
    description:
      '<p>Understanding perceptions and preferences fosters better relationships, critical for success. Learn to recognize biases, avoid assumptions, and adapt communication styles for productive interactions.</p>',
    progress_color: '#6300f5',
    disabled: false,
  },
  {
    id: '8302a4a4-f22a-4cdb-8254-c0122317f6c9',
    module_id: '74629550-e06b-4a7a-a59e-2d16b5c84447',
    name: 'Emotional Intelligence in the Workplace',
    course_image: emotional_intelligence_img,
    sections: [
      {
        id: 'da65a766-f5e6-4217-8901-6dfbd03e15d7',
        name: 'INTRODUCTION',
        chapters: [
          {
            id: 'd5eca8f6-5731-4588-b531-0e596d27adc8',
            name: 'What Is Emotional Intelligence?',
            index: 1,
            content: EmotionalIntelligence1,
            completion_percentage: 13,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_1/Emotional+Intelligence-01-01.mp4',
            ],
          },
        ],
      },
      {
        id: '2225f28a-82b6-4479-94d5-570d7988929f',
        name: 'Personal Competence',
        chapters: [
          {
            id: '9339fd90-854d-4757-91cd-ce240fb8ef8b',
            name: 'Improving Self-Awareness',
            index: 2,
            content: EmotionalIntelligence2,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_2/Emotional+Intelligence-02-01.mp4',
            ],
          },
          {
            id: '3f0f5e32-3bb7-41d2-80e7-32793b55a10b',
            name: 'Boosting Self-Regulation',
            index: 3,
            content: EmotionalIntelligence3,
            completion_percentage: 13,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_3/Emotional+Intelligence-03-01.mp4',
            ],
          },
          {
            id: '630bdddb-d573-4c8a-af3c-9a17b8a636fb',
            name: 'Increasing Self-Motivation',
            index: 4,
            content: EmotionalIntelligence4,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_4/Emotional+Intelligence-04-01.mp4',
            ],
          },
        ],
      },
      {
        id: '942711d5-690b-41e6-9686-a96e8d36b714',
        name: 'Social Competence',
        chapters: [
          {
            id: 'b56d8d23-4081-4293-9c3a-be1a5fca2a2f',
            name: 'Developing Empathy',
            index: 5,
            content: EmotionalIntelligence5,
            completion_percentage: 13,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_5/Emotional+Intelligence-05-01.mp4',
            ],
          },
          {
            id: 'e029a466-ade8-4a26-8f44-0d4ea394e550',
            name: 'Enhancing Social Skills',
            index: 6,
            content: EmotionalIntelligence6,
            completion_percentage: 12,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/emotional_intelligence_in_the_workplace/chapter_6/Emotional+Intelligence-06-01.mp4',
            ],
          },
        ],
      },
      {
        id: '3ef39f1e-fda4-408f-96d0-7891943bd1e0',
        name: 'Conclusion',
        chapters: [
          {
            id: '8600f489-f14b-4943-89cd-ae99076442cf',
            name: 'Summary',
            index: 7,
            content: EmotionalIntelligence7,
            completion_percentage: 13,
          },
          {
            id: '94d3c511-f514-4a7d-8e97-1d1230d99ca3',
            name: 'Quiz',
            index: 8,
            content: EmotionalIntelligenceQuiz,
            completion_percentage: 12,
            disableContentScroll: true,
          },
        ],
      },
    ],
    description:
      '<p>Learn emotional intelligence—recognize and manage your emotions (self-awareness, self-regulation) and others to improve personal and social skills leading to better decision-making.</p>',
    progress_color: '#6300f5',
    disabled: true,
    disabled_description:
      'Please complete Perception & Understanding Preferences module before starting this module. Thanks',
  },
  {
    id: 'c0d5913a-ff0d-4e0a-8932-82fad1e35829',
    module_id: '74629550-e06b-4a7a-a59e-2d16b5c84447',
    name: 'Adapting to Change',
    course_image: adapting_to_change_img,
    sections: [
      {
        id: '483dca09-282f-46f9-b4fb-21a6833f7dd8',
        name: '',
        chapters: [
          {
            id: 'f1ab52f3-1be6-4b79-b893-f888bbf85561',
            name: 'Why Do We Struggle With Change?',
            index: 1,
            content: AdaptingToChange1,
            completion_percentage: 20,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_2/adapting_to_change/Adapating+to+change-01-01.mp4',
            ],
          },
          {
            id: '8b8d1c69-6b57-448e-a31c-c94a442c6f89',
            name: 'Common Reactions To Change',
            index: 2,
            content: AdaptingToChange2,
            completion_percentage: 20,
          },
          {
            id: '40909258-081c-48a5-8767-2b8ebfc85fdc',
            name: '4 Strategies for Accepting Change',
            index: 3,
            content: AdaptingToChange3,
            completion_percentage: 20,
          },
          {
            id: 'acc03c50-2105-4fac-bda5-df50e6441a08',
            name: 'Summary',
            index: 4,
            content: AdaptingToChange4,
            completion_percentage: 20,
          },
          {
            id: '44b07e1b-0477-4f62-a22a-16075ca2650a',
            name: 'Quiz',
            index: 5,
            content: AdaptingToChangeQuiz,
            disableContentScroll: true,
            completion_percentage: 20,
          },
        ],
      },
    ],
    description:
      '<p>Adapting to Change: Learn why we struggle with workplace change, identify the five emotional stages and how to use coping strategies for maximum career success.</p>',
    progress_color: '#fd7701',
    disabled: true,
    disabled_description:
      'Please complete Emotional Intelligence in the Workplace module before starting this module. Thanks',
  },
  {
    id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    module_id: '18473415-771b-431d-9d95-3e5dff0c9a17',

    name: 'Collaboration Fundamentals',
    course_image: collaboration_fundamentals_img,
    sections: [
      {
        id: '012c55ba-e569-4dd2-a620-e21019a77db0',
        name: '',
        chapters: [
          {
            id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
            name: 'Overview',
            index: 1,
            content: CollaborationFundamentalsChapter1,
            completion_percentage: 12.5,
            course_video_url: [],
          },
          {
            id: 'b694f414-cc98-4374-9fbe-e559b41d36c9',
            name: 'What is Collaboration',
            index: 2,
            content: CollaborationFundamentalsChapter2,
            completion_percentage: 12.5,
          },
          {
            id: '0fcb3269-0afb-4208-936c-7cf12837a534',
            name: 'Collaboration-A Critical Skill',
            index: 3,
            content: CollaborationFundamentalsChapter3,
            completion_percentage: 12.5,
          },
          {
            id: '2869eca3-9590-41e2-b10c-1d20348cf76f',
            name: 'Collaboration in Action',
            index: 4,
            content: CollaborationFundamentalsChapter4,
            completion_percentage: 12.5,
          },
        ],
      },
      {
        id: '67780765-defb-4cba-a395-8ba199b6c851',
        name: 'Engagment Preferences',
        chapters: [
          {
            id: '8125f823-848a-47c5-9165-0c3b14edbb8b',
            name: 'Social Perceptiveness',
            index: 5,
            content: CollaborationFundamentalsChapter5,
            disableContentScroll: false,
            completion_percentage: 12.5,
          },
          {
            id: '0896c02d-b656-40e5-9c1b-0598e8a198d6',
            name: 'Insights Discovery Color Energies',
            index: 6,
            content: CollaborationFundamentalsChapter6,
            disableContentScroll: false,
            completion_percentage: 12.5,
          },
        ],
      },
      {
        id: '3334eaec-3a23-4f0d-aeb0-b1e0e239ffee',
        name: 'Conclusion',
        chapters: [
          {
            id: '39fda3f5-e22f-4e72-9d63-057c7a841850',
            name: 'Summary',
            index: 7,
            content: CollaborationFundamentalsChapter7,
            disableContentScroll: false,
            completion_percentage: 12.5,
          },
          {
            id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
            name: 'Quiz',
            index: 8,
            content: CollaborationFundamentalsQuiz,
            disableContentScroll: false,
            completion_percentage: 12.5,
          },
        ],
      },
    ],
    description:
      '<p>Master the essentials of working with others—communicate clearly, solve problems fast, and handle real-world teamwork like a pro. Built for jobs, life, and everything in between.</p>',
    progress_color: '#fd7701',
    disabled: true,
    disabled_description:
      'Please complete Emotional Intelligence in the Workplace module before starting this module. Thanks',
  },
  {
    id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    module_id: '32464450-01fa-4ed0-abbc-1a1b5f733ca5',

    name: 'Team Players: Roles, Responsibilities, and Effective Collaboration',
    course_image: team_players_img,
    sections: [
      {
        id: '871304a1-2637-49c5-960f-16eddb2f82ea',
        name: '',
        chapters: [
          {
            id: '0f4b90a5-73d3-464e-9a58-d6f0408ad39b',
            name: 'Overview',
            index: 1,
            content: TeamPlayersChapter1,
            completion_percentage: 11.11,
            course_video_url: [],
          },
          {
            id: 'db1c33f6-fab3-48b7-8219-1f2884405508',
            name: 'Team Roles',
            index: 2,
            content: TeamPlayersChapter2,
            completion_percentage: 11.11,
            course_video_url: [],
          },
          {
            id: 'e05cce02-a347-4b76-8f05-23fa2da3114a',
            name: 'Phases of a Team Task',
            index: 3,
            content: TeamPlayersChapter3,
            completion_percentage: 11.11,
            course_video_url: [],
          },
          {
            id: '6050f3a2-b7b3-40dd-baed-f988d53ef08a',
            name: 'Characteristics of a Great Team',
            index: 4,
            content: TeamPlayersChapter4,
            completion_percentage: 11.11,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module4/chapter3/Characteristics_of_an_Effective_Team_20Aug24+(1).mp4',
            ],
          },
          {
            id: '83ba282d-5285-404d-b904-10a16c3222be',
            name: 'Assessing & Using Your Teamwork Strengths',
            index: 5,
            content: TeamPlayersChapter5,
            completion_percentage: 11.11,
            course_video_url: [],
          },
          {
            id: '6af5fa2f-a12a-4079-97ee-4116aed6f0db',
            name: 'Assessing & Managing Your Weaknesses',
            index: 6,
            content: TeamPlayersChapter6,
            completion_percentage: 11.11,
            course_video_url: [],
          },
          {
            id: '52680e98-a257-44ba-9da2-74e496d3246c',
            name: 'Understand the Value Others Bring to the Team',
            index: 7,
            content: TeamPlayersChapter7,
            completion_percentage: 11.11,
            course_video_url: [],
          },
        ],
      },
      {
        id: 'b31cfe79-3ebb-4529-8ac3-f901a484c93f',
        name: 'Conclusion',
        chapters: [
          {
            id: '6f555472-d39f-4cf3-a310-1ed7080a1276',
            name: 'Summary',
            index: 8,
            content: TeamPlayersChapter8,
            disableContentScroll: false,
            completion_percentage: 11.11,
          },
          {
            id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
            name: 'Quiz',
            index: 9,
            content: TeamPlayersChapterQuiz,
            disableContentScroll: false,
            completion_percentage: 11.11,
          },
        ],
      },
    ],
    description:
      '<p>Find your role, play to your strengths, and make your team stronger. Learn what makes high-performing teams work—and how to be the one they rely on.</p>',
    progress_color: '#fd7701',
    disabled: true,
    disabled_description:
      'Please complete Collaboration Fundamentals module before starting this module. Thanks',
  },
  {
    id: 'e38707f6-e7fe-4b5f-aff0-54dcc6d6e320',
    module_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',

    name: 'Building Your Teamwork & Collaboration Skills',
    course_image: team_players_collaboration_img,
    sections: [
      {
        id: '14899aad-9b04-4607-aaa9-06724d5beacd',
        name: 'Introduction',
        chapters: [
          {
            id: '2657f34f-bb14-4df5-8dcc-799910479b0f',
            name: 'Overview',
            index: 1,
            content: TeamPlayersAndCollaborationChapter1,
            completion_percentage: 6.67,
            course_video_url: [],
            disableContentScroll: false,
          },
        ],
      },
      {
        id: '6969363a-5227-408e-88f3-aafff3cecf50',
        name: 'Cultivate Trusted Relationships',
        chapters: [
          {
            id: '0d6cf1a6-5433-43c7-a656-26cee50be484',
            name: 'Engage Fully',
            index: 2,
            content: TeamPlayersAndCollaborationChapter2,
            completion_percentage: 6.67,
            course_video_url: [],
            disableContentScroll: false,
          },
          {
            id: '826d8782-6d46-42a5-9825-0309492f010d',
            name: 'Manage Expectations & Foster Trust',
            index: 3,
            content: TeamPlayersAndCollaborationChapter3,
            completion_percentage: 6.67,
            course_video_url: [],
            disableContentScroll: false,
          },
        ],
      },
      {
        id: 'f8dcf661-9ced-4e87-bc6c-a42368a07756',
        name: 'Psychological Safety',
        chapters: [
          {
            id: '5b974daf-36c1-4cbe-a104-0377008723e5',
            name: 'Foster Psychological Safety',
            index: 4,
            disableContentScroll: false,
            content: TeamPlayersAndCollaborationChapter4,
            completion_percentage: 6.67,
            course_video_url: [
              'https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/module_6/chapter4/Foster_Psychological_Safety_section_module3_chap4.mp4',
            ],
          },
        ],
      },
      {
        id: 'cbcfa5e6-6c99-4c00-ae43-00b89f700353',
        name: 'Team Culture',
        chapters: [
          {
            id: '8efcbfd5-9a0a-43fd-a730-6016238f8d6a',
            name: 'What is Team Culture',
            index: 5,
            content: TeamPlayersAndCollaborationChapter5,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: '02dd49cf-08fc-4067-9821-440afbb6f227',
            name: 'Becoming a Team Culture Creator',
            index: 6,
            content: TeamPlayersAndCollaborationChapter6,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
        ],
      },
      {
        id: 'e66a06ca-06f9-40db-bf43-970ee1199b39',
        name: 'Expand Your Strategic Mindset',
        chapters: [
          {
            id: 'ea24c4bb-3832-4653-aa18-799aaf9b0669',
            name: 'Hone Your Strategy Skills',
            index: 7,
            content: TeamPlayersAndCollaborationChapter7,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: '963a1575-4bb7-4663-84f4-8b0243ff2c88',
            name: 'Develop Your Solution-Orientation',
            index: 8,
            content: TeamPlayersAndCollaborationChapter8,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
        ],
      },
      {
        id: '0942ff99-0dc1-4d38-85ce-195ff88beed1',
        name: 'Difficulties That Teams Face',
        chapters: [
          {
            id: '47c51b5a-1942-4186-9cd3-d1d1605b9d14',
            name: 'Why is Collaboration Hard Sometimes',
            index: 9,
            content: TeamPlayersAndCollaborationChapter9,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: '819396a0-4ec1-4802-8939-478146f4f2c8',
            name: 'Confidently Navigate Conflict',
            index: 10,
            content: TeamPlayersAndCollaborationChapter10,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
            name: 'Avoid Risky Shift & Groupthink',
            index: 11,
            content: TeamPlayersAndCollaborationChapter11,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
            name: 'Team Behaviors to Avoid',
            index: 12,
            content: TeamPlayersAndCollaborationChapter12,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
        ],
      },
      {
        id: 'b7587122-74f9-40f1-a8c9-37dffef5b06c',
        name: 'Take Action',
        chapters: [
          {
            id: '4cd4b601-bc87-4456-a1d8-590ba6d6219a',
            name: 'Teamwork Roadmap',
            index: 13,
            content: TeamPlayersAndCollaborationChapter13,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
        ],
      },
      {
        id: 'f4151c8c-f62a-4efe-833c-72bfc7cf1b99',
        name: 'Conclusion',
        chapters: [
          {
            id: '8ba6bcd5-6e51-4f5e-b0b0-3fad272ef898',
            name: 'Summary',
            index: 14,
            content: TeamPlayersAndCollaborationChapter14,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
          {
            id: 'd0ac1eae-d388-416b-bac5-d7b24487921a',
            name: 'Post-Assessment',
            index: 15,
            content: Quiz,
            disableContentScroll: false,
            completion_percentage: 6.67,
          },
        ],
      },
    ],
    description:
      '<p>Step into leadership by learning how to listen, speak up, and lead under pressure. Practice real teamwork tools so you’re ready for the floor, the field, or the front line.</p>',
    progress_color: '#fd7701',
    disabled: true,
    disabled_description: 'Please complete Team Players module before starting this module. Thanks',
  },
];
